export default "__VITE_ASSET__BFhN1c0f__"